import {useEffect, useRef, useState} from "react";
import isNull from "../mixin/isNull";
import {ZonedDateTime} from "@js-joda/core";
import useIdpRepository from "../repository/auth/useIdpRepository";
import {useSearchParams} from "react-router-dom";
import database from "../database/database";

export default function () {
    const [initialized, setInitialized] = useState(false);
    const [searchParams] = useSearchParams();
    const interval = useRef();
    const idpRepository = useIdpRepository();

    useEffect(() => {
        interval.current = setInterval(checkExpV2, 10000);
        checkExpV2();
    }, []);

    useEffect(() => {
        return () => clearInterval(interval.current);
    }, []);


    const checkExpV2 = async () => {
        if (localStorage.getItem("test") == "true") {
            setInitialized(true);
            return;
        }

        const exp = database.read(database.TABLE_AUTHENTICATION, "exp");
        const margin = 30;

        if (isNull(exp) || exp === "" || exp - margin < ZonedDateTime.now().toEpochSecond()) {
            await idpRepository.refresh();
        }

        if (!initialized) {
            setInitialized(true);
        }
    }

    return initialized;
}